import classNames from 'classnames';
import { useProductCardContext } from 'palette/ProductCard/ProductCardContext';
import { ISingleItemData } from 'palette/ProductCard/types/productData';
import { BodyText } from 'palette/Typography';

import './SingleItemDetails.scss';

interface SingleItemDetailsProps {
    data: ISingleItemData;
}

const getValue = (
    value: string, label?: string, includeKey: boolean = true,
) => (includeKey && label ? `${label} : ${value}` : value);

function SingleItemDetails({
    data,
}: SingleItemDetailsProps) {
    const { hasToShowSingleItemDataAsList, cardLabels } = useProductCardContext();
    const {
        quantity, size, colorName, status,
    } = data;

    return (
        <div className="palette-product-card-single-item-details">
            <div className={classNames('palette-product-card-single-item-details__size-and-color', {
                'palette-product-card-single-item-details__size-and-color--flex-column': hasToShowSingleItemDataAsList,
            })}
            >
                {
                    size
                    && (
                        <BodyText
                            className="palette-product-card-single-item-details__size"
                            color="light"
                        >
                            {getValue(size, 'Size', hasToShowSingleItemDataAsList)}
                        </BodyText>
                    )
                }
                {
                    colorName
                    && (
                        <BodyText
                            className={classNames('palette-product-card-single-item-details__color', {
                                'palette-product-card-single-item-details__color--inline': !hasToShowSingleItemDataAsList,
                            })}
                            color="light"
                        >
                            {getValue(colorName, 'Color', hasToShowSingleItemDataAsList)}
                        </BodyText>
                    )
                }
            </div>
            {
                !!quantity
                && (
                    <BodyText
                        className="palette-product-card-single-item-details__quantity"
                        color="light"
                    >
                        {getValue(quantity, cardLabels.quantity)}
                    </BodyText>
                )
            }
            {
                status
                && (
                    <BodyText
                        className="palette-product-card-single-item-details__status"
                        color="light"
                    >
                        {getValue(status, 'Status')}
                    </BodyText>
                )
            }
        </div>
    );
}

export default SingleItemDetails;
